import { module } from 'angular';

import { default as responseMessageViewName, ResponseMessageView } from './response-message-view.component.ajs';

export default module('contact.responder.response-message-view', []).component(responseMessageViewName, new ResponseMessageView()).name;
